// import { useEffect } from 'react';
// import axios from 'axios';
// import { useAuth } from '../context/AuthContext';

// const useAxiosAuth = () => {
//   const { user, baseURL } = useAuth();

//   useEffect(() => {
//     if (baseURL) {
//       axios.defaults.baseURL = baseURL;  // Set base URL from AuthContext
//     }

//     const requestIntercept = axios.interceptors.request.use(
//       async (config) => {
//         if (!config.headers['Authorization'] && user) {
//           const token = await user.getIdToken();
//           config.headers['Authorization'] = `Bearer ${token}`;
//         }
//         return config;
//       },
//       (error) => Promise.reject(error)
//     );

//     return () => {
//       axios.interceptors.request.eject(requestIntercept);
//     };
//   }, [user, baseURL]);

//   return axios;
// };

// export default useAxiosAuth;

import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useEffect } from 'react';

const useAxiosAuth = () => {
  const { user, baseURL } = useAuth();

  useEffect(() => {
    if (baseURL) {
      axios.defaults.baseURL = baseURL;  // Set the base URL once
    }

const requestIntercept = axios.interceptors.request.use(
  async (config) => {
    if (!config.headers['Authorization'] && user) {
      const token = await user.getIdToken();
      console.log("Attaching token to request:", token);  // Log the token
      config.headers['Authorization'] = `Bearer ${token}`;
    } else {
      console.log("Request already has an Authorization header.");
    }
    return config;
  },
  (error) => Promise.reject(error)
);

    // Cleanup the interceptor on unmount
    return () => {
      axios.interceptors.request.eject(requestIntercept);
    };
  }, [user, baseURL]);

  return axios;  // Return the configured Axios instance
};

export default useAxiosAuth;

